//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LANGUAGE } from "./store/mutation-types";
import moment from "moment";
import { languageDirectionRtl } from "./utils/plugin_helper";
import paypalErrorConfirm from "./components/payment/paypal_error_confirm/Index";

export default {
  name: "app",
  components: { paypalErrorConfirm },
  data() {
    return {
      showPayLoading: false,
    };
  },
  computed: {
    rtl: languageDirectionRtl,
  },
  async created() {
    // 页面加载之时判断设备所选语言
    let language = this.$store.getters[LANGUAGE];
    // 然后切换语言
    console.log("language", language);
    this.$i18n.set(language);
    moment.locale(language);
  },
};



// WEBPACK FOOTER //
// ./src/App.vue